import { useMutation } from 'react-query';
import axios from 'axios';
import { apiurl } from '../../../config/apiUrl';
import showAlert from '../../../utils/alert';

const downloadPOQuery = async (id, poNumber) => {
    return axios
    .get(`${apiurl?.downloadPO}/${id}`, {
      responseType: 'blob'
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${poNumber}.pdf`); // or any other extension
        document.body.appendChild(link);
        link.click();
    }).catch(() => {
        showAlert('Something went wrong', 'error');
    });
};

const downloadPO = (id, poNumber) => {
    return useMutation(['downloadPO'],
        () => downloadPOQuery(id, poNumber), { refetchOnWindowFocus: false });
};

export default downloadPO;
